import React from "react";
import {
    Skeleton,
    Box,
} from "@mui/material";

const ArticlesSkeleton = () => {
    const skeletonRows = Array.from({ length: 10 }, (_, index) => index);

    return (
        <Box sx={{ mt: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* Header Skeleton */}
            <Box sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "24px minmax(200px,1fr) 120px 140px 150px 100px 100px 48px",
                    sm: "24px minmax(250px,1fr) 150px 150px 180px 120px 110px 48px",
                    md: "24px minmax(300px,1fr) 170px 160px 180px 140px 120px 48px",
                    lg: "24px minmax(300px,1fr) 170px 160px 170px 140px 120px 48px"
                },
                gap: 0,
                alignItems: "center",
                px: 0,
                height: 48,
                position: 'sticky',
                top: 0,
                background: '#fff',
                minWidth: 'fit-content',
            }}>
                <Skeleton variant="rectangular" width={16} height={16} sx={{ borderRadius: "4px" }} />
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton variant="text" width={80} height={20} />
                <Box />
            </Box>

            {/* Rows Skeleton */}
            <Box sx={{ flex: 1, overflow: 'auto' }}>
                {skeletonRows.map((index) => (
                    <Box
                        key={index}
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "24px minmax(200px,1fr) 120px 140px 150px 100px 100px 48px",
                                sm: "24px minmax(250px,1fr) 150px 150px 180px 120px 110px 48px",
                                md: "24px minmax(300px,1fr) 170px 160px 180px 140px 120px 48px",
                                lg: "24px minmax(300px,1fr) 170px 160px 170px 140px 120px 48px",
                            },
                            gap: 0,
                            alignItems: "center",
                            px: 0,
                            height: 64,
                            borderTop: "1px solid #EEF2F6",
                            minWidth: 'fit-content',
                        }}
                    >
                        <Skeleton variant="rectangular" width={16} height={16} sx={{ borderRadius: "4px" }} />

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Skeleton variant="text" width={200} height={24} sx={{ borderRadius: '6px' }} />
                            {/* <Skeleton variant="rectangular" width={16} height={16} /> */}
                        </Box>

                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: "4px" }} />

                        <Skeleton variant="text" width={100} height={20} />

                        <Skeleton variant="text" width={120} height={20} />

                        <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: "5px" }} />

                        <Skeleton variant="text" width={80} height={20} />

                        <Skeleton variant="circular" width={24} height={24} sx={{ ml: 1 }} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default ArticlesSkeleton;
